export default "__VITE_ASSET__CvonCRMZ__"